import { Component, OnInit } from '@angular/core';
import { map } from 'rxjs/operators';
import { DealsService } from 'src/app/services/deals.service';
import { DealPipelineWorkflowService } from 'src/app/services/settings-services/deal-pipeline-workflow.service';
import DateUtils from 'src/app/utils/date';

@Component({
  selector: 'app-deal-stage-duration',
  templateUrl: './deal-stage-duration.component.html',
  styleUrls: ['./deal-stage-duration.component.css']
})
export class DealStageDurationComponent implements OnInit {
  dateUtil = new DateUtils;
  dateRange = { startDate: null, endDate: null }
  showChart = true;
  workflows$;
  selectedWorkflow = '';
  dealsData;
  stages;
  public chartOptions = {
    series: [
      {
        name: "days",
        data: [2, 1, 4, 3, 2]
      },
    ],
    chart: {
      type: "bar",
      height: 300
    },
    plotOptions: {
      bar: {
        horizontal: true,
        // distributed: true,
        // columnWidth: '30%',
      }
    },
    dataLabels: {
      enabled: false
    },
    yaxis: {
      title: {
        text: `stages`,
      },
    },
    xaxis: {
      categories: ['Stage 1', 'Stage 2', 'Stage 3', 'Stage 4', 'Stage 5'],
      title: {
        text: 'days'
      }
    },
    tooltip: {
      y: {
        formatter: function (val) {
          return this.baseCurrency + val;
        }
      }
    }
    // colors: [  "rgb(255,177,193))", "rgb(154,208,245)", "rgb(255,230,170)"]
  };
  constructor(
    private dealSrv: DealsService,
    private dealWorkflow: DealPipelineWorkflowService) {
    this.dateRange = this.dateUtil.getDefReportDateRange();
    this.workflows$ = this.dealWorkflow.getDealsPipelineWorkflow();
  }
  ngOnInit() {
  }
  getStages() {
    this.showChart = false
    this.stages = {};
    const stageIds = [];
    this.dealWorkflow.getDealsPipelineStageByDealId(this.selectedWorkflow).pipe(map((stages: any) => {
      return stages.filter(stage => !(stage.name === 'Won' || stage.name === 'Lost'))
    })).subscribe((data: any[]) => {
      data.forEach(dat => {
        this.stages[dat.id] = dat
        stageIds.push(dat.id);
      })
      this.getStageDurStats(stageIds);
    });
  }
  getDays(total) {
    return Math.floor(total / 86400000)
  }

  getStageDurStats(stageIds) {
    const stagesDur = [];
    const stageName = []
    this.dealSrv.fetchStageDurStats(stageIds).pipe(map((deals: any[]) => {
      return deals.map(deal => ({ ...deal, name: this.stages[deal.id].name, days: this.getDays(deal.total) }))
    }))
      .subscribe((stages: any[]) => {
        this.dealsData = stages;
        stages.forEach(stage => {
          stageName.push(stage.name)
          stagesDur.push(stage.days)
        });
        this.chartOptions.series[0].data = stagesDur;
        this.chartOptions.xaxis.categories = stageName;
        this.showChart = true
      })
  }

}
